import _typeof from "@babel/runtime-corejs3/helpers/typeof";import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";import { action, makeObservable, observable, toJS } from 'mobx';















export var BasicFormController = /*#__PURE__*/function () {











































































































  function BasicFormController(fields) {var userRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];_classCallCheck(this, BasicFormController);_defineProperty(this, "onChangeTimeout", null);
    this.fields = fields;
    this.userRoles = userRoles;

    makeObservable(this, {
      fields: observable,
      onFieldChange: action.bound,
      onCheckboxChange: action.bound,
      resetForm: action.bound,
      populateFields: action.bound,
      getFormDataObject: action.bound,
      setOnChangeTimeout: action.bound,
      isFormValid: action.bound,
      setSecondLevelValidation: action.bound
    });
  }_createClass(BasicFormController, [{ key: "onFieldChange", value: // Data
    // Methods
    function onFieldChange(e) {this.fields[e.target.name].value = e.target.value;this.fields[e.target.name].secondLevelValidationMessage = '';} }, { key: "onCheckboxChange", value: function onCheckboxChange(e) {this.fields[e.target.name].value = e.currentTarget.checked;} // Resets all the form fields to their initial values.
  }, { key: "resetForm", value: function resetForm() {var _this = this;_Object$keys(this.fields).forEach(function (fieldName) {_this.fields[fieldName].value = _this.fields[fieldName].initialValue;_this.fields[fieldName].secondLevelValidationMessage = '';});} // Method set secondLevelValidation field to display error that can be verified only on BE
  }, { key: "setSecondLevelValidation", value: function setSecondLevelValidation(dataObj) {var _this2 = this;_Object$keys(dataObj).forEach(function (fieldName) {if (_typeof(dataObj[fieldName]) === 'object' && dataObj[fieldName] !== null) {_this2.populateFields(dataObj[fieldName]);}if (Object.prototype.hasOwnProperty.call(_this2.fields, fieldName)) {_this2.fields[fieldName].secondLevelValidationMessage = dataObj[fieldName] === undefined || dataObj[fieldName] === null ? '' : dataObj[fieldName];}});} // Sets a timeout with onChange function call, and with callback if one is provided as a last
    // argument.
  }, { key: "setOnChangeTimeout", value: function setOnChangeTimeout(e, offset, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback) {if (this.onChangeTimeout !== null) {clearTimeout(this.onChangeTimeout);this.onChangeTimeout = null;}var formFields = toJS(this.fields);this.onChangeTimeout = setTimeout(function () {if (callback) {callback(formFields[e.target.name].value);}}, offset);this.onFieldChange(e);} // Accepts an object with key-value pairs. Recursively iterates over each of the accepted object
    // keys, and if there is a key with the same name in the this.fields object - copies the former
    // key value to the latter one. If there is an inadequate value in the dataObj the corresponding
    // property in the fields object will receive it's 'initialValue' property value.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, { key: "populateFields", value: function populateFields(dataObj) {var _this3 = this;var postAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};_Object$keys(dataObj).forEach(function (fieldName) {if (_typeof(dataObj[fieldName]) === 'object' && dataObj[fieldName] !== null) {_this3.populateFields(dataObj[fieldName]);}if (Object.prototype.hasOwnProperty.call(_this3.fields, fieldName)) {_this3.fields[fieldName].value = dataObj[fieldName] === undefined || dataObj[fieldName] === null ? _this3.fields[fieldName].initialValue : dataObj[fieldName];postAction(fieldName);}});} // Retrieve all the form data in one object.
  }, { key: "getFormDataObject", value: function getFormDataObject() {var _this4 = this;var resultDataObj = {};_Object$keys(this.fields).forEach(function (fieldName) {var _context;resultDataObj[fieldName] = typeof _this4.fields[fieldName].value === 'string' ? _trimInstanceProperty(_context = _this4.fields[fieldName].value).call(_context) : _this4.fields[fieldName].value;});return resultDataObj;} }, { key: "isFormValid", value: function isFormValid() {var _this5 = this;var allFieldsValid = true;_Object$keys(this.fields).forEach(function (fieldName) {if (!allFieldsValid) {return;}if (_this5.fields[fieldName].unpassedValidationMsg) {allFieldsValid = false;}});return allFieldsValid;} }]);return BasicFormController;}();
//# sourceMappingURL=BasicFormController.js.map